// 我的档案相关
const vipCourse = () => import('@/pages/vipProduct/index.vue');
const vipService = () => import('@/pages/vipProduct/service.vue');
const vipExperienceProduct = () => import('@/pages/vipProduct/experienceProduct.vue');
const vipExperience = () => import('@/pages/vipProduct/experience.vue');

export default [
  {
    path: '/vipCourse',
    component: vipCourse,
  },
  {
    path: '/vipService',
    component: vipService,
  },
  {
    path: '/vipExperienceProduct',
    component: vipExperienceProduct,
  },
  {
    path: '/vipExperience',
    component: vipExperience,
  },
];

